import type { Project } from '../../../../types';

/**
 * Takes a project and determines if there is a last analyzed revision, last resolved revision, or head revision.
 *
 * @param {Project | undefined} project - A project object (may be undefined)
 * @returns {string | null} The revision string, or null if no revision is found.
 */
export function getLatestRevisionIdFromProject(project?: Project): string | null {
  // First we check if there is a last analyzed revision (latest version to be policy scanned)
  if (project?.last_analyzed?.loc) {
    return project.last_analyzed.loc.revision;
  }
  // Second we check if there is a last resolved revision (latest version to be analyzed by FOSSA)
  if (project?.latest?.loc) {
    return project.latest.loc.revision;
  }
  // Since there aren't any revisions that been analyzed or resolved, we default to the head revision (latest version of the branch or tag)
  if (project?.head?.loc) {
    return project.head.loc.revision;
  }
  return null;
}
